module.exports = "<button\n    ng-click=\"displayInfo()\"\n    ng-if=\"helpText\"\n    ng-include=\"'/qnb/styles/images/icons/icon-nav-info.svg'\"\n    title=\"\"\n></button>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-info-button.html
// module id = 546
// module chunks = 0